import React from 'react';
import { testimonials } from '../mockData';

const Testimonials = () => {
  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto space-y-32">
        {testimonials.map((testimonial, index) => (
          <div
            key={testimonial.id}
            className={`flex flex-col ${index % 2 === 0 ? 'items-start' : 'items-end'} text-${index % 2 === 0 ? 'left' : 'right'}`}
          >
            <blockquote className="text-2xl md:text-3xl lg:text-4xl font-light text-gray-900 italic mb-6 max-w-3xl">
              {testimonial.quote}
            </blockquote>
            <cite className="text-lg text-gray-600 not-italic">
              {testimonial.author}
            </cite>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;